export const measurementUnitTypes = {
  METRIC: 'metric',
  IMPERIAL: 'imperial'
} as const;

// For a full list see:
// https://github.com/strava/active/blob/a1ae434384fbb7c20f880704305e9cf07dd968a8/lib/activities/types.rb
export const activityTypes = {
  RIDE: 1,
  HIKE: 4,
  RUN: 9,
  WALK: 10,
  SWIM: 16,
  VIRTUAL_RIDE: 17,
  VIRTUAL_RUN: 53
} as const;

export const ridelikeTypes = [
  'ride',
  'virtual_ride',
  'e_bike_ride',
  'velomobile',
  'handcycle'
];

export const runlikeTypes = ['run', 'virtual_run', 'wheelchair'];

// see active/lib/activities/workouts.rb for a full list
export const workoutTypes = {
  RUN_DEFAULT: 0,
  RUN_RACE: 1,
  RUN_LONG: 2,
  RUN_INTERVAL: 3,
  RIDE_DEFAULT: 10,
  RIDE_RACE: 11,
  RIDE_INTERVAL: 12
} as const;

export const athleteTypes = {
  CYCLIST: 0,
  RUNNER: 1
} as const;

// These are the route types as specified in Active
//
// Based on routing thrift definition
// https://github.com/strava/routing/blob/e0f8503caac4facef8df0955f314b4be521385d8/routing-interface/src/main/thrift/routing.thrift#L18-L55
export const routeTypes = {
  RIDE: 1,
  RUN: 2,
  WALK: 3,
  HIKE: 4,
  TRAIL_RUN: 5,
  GRAVEL_RIDE: 6,
  MOUNTAIN_BIKE_RIDE: 7,
  E_MOUNTAIN_BIKE_RIDE: 8,
  E_BIKE_RIDE: 9,
  SWIM: 10,
  KAYAK: 11,
  GOLF: 12,
  SAIL: 13,
  CANOE: 14,
  ALPINE_SKI: 15,
  BACKCOUNTRY_SKI: 16,
  ICE_SKATE: 17,
  INLINE_SKATE: 18,
  HANDCYCLE: 19,
  KITESURF: 20,
  NORDIC_SKI: 21,
  ROCK_CLIMBING: 22,
  ROLLER_SKI: 23,
  ROWING: 24,
  SKATEBOARD: 25,
  SNOWSHOE: 26,
  STAND_UP_PADDLE: 27,
  SURFING: 28,
  VELOMOBILE: 29,
  WINDSURF: 30,
  WHEELCHAIR: 31
} as const;

// Based on routing thrift definition
// https://github.com/strava/routing/blob/9e5e302c7c2490fa32a1499f7485964aeac0179a/routing-interface/src/main/thrift/routing.thrift#L9-L16
export const savedRouteSources = {
  EPHEMERAL: 1,
  CANONICAL: 2,
  MOBILE_SKETCH_A_ROUTE: 3,
  MOBILE_ROUTE_FROM_ACTIVITY: 4,
  WEB_ROUTE_FROM_ACTIVITY: 5,
  WEB_ROUTE_BUILDER: 6
} as const;

// Based on routing thrift definition
// https://github.com/strava/routing/blob/c2e86db37bb703234c0c18637cd626dc8263a5ec/routing-interface/src/main/thrift/routing.thrift#L16
export const routeSubtypes = {
  ROAD: 1,
  MTB: 2,
  CX: 3,
  TRAIL: 4,
  MIXED: 5
} as const;

export const routeLegTypes = {
  // user-specified fixed path
  FIXED: 1,
  // we figured out the leg from the basemap
  SEARCH: 2,
  // came from a Google lookup
  GOOGLE: 3,
  // user-specified segment
  SEGMENT: 4,
  // generated from an activity
  ACTIVITY: 5
} as const;

// Based on routing thrift definition
// https://github.com/strava/routing/blob/4476c6235a2c9ee4ba9804d95fb92195e05c18d3/routing-interface/src/main/thrift/routing.thrift#L65-L69
export const surfaceType = {
  PAVED: 1,
  UNPAVED: 2,
  UNKNOWN: 3
} as const;
